import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { getConfig } from '@tcs/client-portal/config/configService';

let oktaAuth: OktaAuth;

export const getOktaAuth = () => {
  const config = getConfig();

  oktaAuth =
    oktaAuth ??
    new OktaAuth({
      issuer:
        config.OKTA_ISSUER ||
        'https://forgecustodyplatform.oktapreview.com/oauth2/aus1twt9ehcvR4Q4j1d7',
      clientId: config.OKTA_CLIENT_ID || '0oa1twx8ui7wFlRJ31d7',
      scopes: ['openid', 'profile', 'account:read'],
      redirectUri: `${window.location.origin}${config.REACT_APP_BASE_PATH}/login/callback`,
      postLogoutRedirectUri: `${window.location.origin}${config.REACT_APP_BASE_PATH}`,
      ignoreLifetime: true,
      pkce: true,
      devMode: true,
      tokenManager: {
        storage: 'cookie',
      },
      cookies: {
        secure: true,
        sameSite: 'strict' as const,
      },
    });

  return oktaAuth;
};

interface Props {
  oktaAuth: OktaAuth;
  children: ReactNode;
}

const SecurityProvider = ({ oktaAuth, children }: Props) => {
  const nav = useNavigate();

  const onAuthRequired = () => {
    nav('/login', { replace: true });
  };

  const restoreOriginalUri = (_, originalUri) => {
    const URI = originalUri ?? '/';
    const basePath = getConfig().REACT_APP_BASE_PATH;

    nav(
      toRelativeUrl(
        URI.replace(basePath, ''),
        `${window.location.origin}${basePath}`,
      ),
      { replace: true },
    );
  };

  return (
    <Security
      oktaAuth={oktaAuth}
      onAuthRequired={onAuthRequired}
      restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  );
};

export default SecurityProvider;
